<!-- Ссылка на заказ: компактная по умолчанию и управляемая карточка в полях связи. -->
<template>
  <BaseRelatedRecordCard
    v-if="relationCard"
    :title="relationTitle"
    :subtitle="relationSubtitle"
    icon="clipboardCheck"
    :to="orderRoute"
    :view-title="viewTitle"
    :remove-title="removeTitle"
    :removable="removable"
    :disabled="disabled"
    @remove="$emit('remove')"
  />

  <RouterLink
    v-else-if="order"
    class="order-entity-link"
    :to="orderRoute"
    @click.stop
  >
    <AppIcon name="clipboardCheck" :size="16" color="#64748b" />
    <span class="order-entity-link__content">
      <strong>{{ cargoName }}</strong>
      <small>{{ dateLabel }}</small>
    </span>
  </RouterLink>

  <span v-else class="order-entity-link order-entity-link--empty">
    <span class="order-entity-link__content">
      <strong>Нет текущего заказа</strong>
    </span>
  </span>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import { formatDate } from "@/utils/dateUtils";

export default {
  name: "OrderEntityLink",

  components: {
    AppIcon,
  },

  props: {
    order: {
      type: Object,
      default: null,
    },
    relationCard: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    removable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["remove"],

  computed: {
    cargoName() {
      return this.order.cargoName || this.order.cargo_name || this.order.title || this.order.number;
    },

    dateLabel() {
      const date = this.order.orderDate || this.order.order_date || this.order.from;
      if (!date) return "Дата не указана";

      return new Intl.DateTimeFormat("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(date));
    },

    relationTitle() {
      if (this.title) return this.title;
      if (!this.order) return "Нет выбранного заказа";
      if (this.order.number) return `Заказ № ${this.order.number}`;

      return this.order.selector_name || `Заказ #${this.order.id}`;
    },

    relationSubtitle() {
      if (this.subtitle) return this.subtitle;
      if (!this.order) return "";

      const route = this.order.route_cities || this.order.routeCities;
      const date = this.order.order_date || this.order.orderDate || this.order.from;

      return [route, date ? formatDate(date) : null].filter(Boolean).join(" · ");
    },

    orderRoute() {
      if (!this.order?.id) return null;

      return { name: "OrderDetails", params: { id: this.order.id } };
    },

    viewTitle() {
      return this.order?.id
        ? `Открыть заказ №${this.order.number || this.order.id} в новой вкладке`
        : "Открыть заказ в новой вкладке";
    },

    removeTitle() {
      return this.order?.id
        ? `Убрать связь с заказом №${this.order.number || this.order.id}`
        : "Убрать связь с заказом";
    },
  },
};
</script>

<style scoped>
.order-entity-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  width: 100%;
  height: 44px;
  min-width: 0;
  padding: 3px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-sizing: border-box;
}

.order-entity-link:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.order-entity-link--empty {
  justify-content: center;
  border-style: dashed;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
}

.order-entity-link--empty .order-entity-link__content {
  flex: 0 1 auto;
  text-align: center;
}

.order-entity-link--empty .order-entity-link__content strong {
  color: #94a3b8;
  font-weight: 600;
}

.order-entity-link__content {
  display: grid;
  flex: 1 1 0;
  min-width: 0;
  text-align: left;
}

.order-entity-link__content strong,
.order-entity-link__content small {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-entity-link__content strong {
  color: #0f172a;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.1;
}

.order-entity-link__content small {
  color: #64748b;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.1;
}
</style>
